import PropTypes from "prop-types";

// Custom components
import GrossBonus from "@PayPlans/components/Defaults/Managers/Departmental/GrossBonus";

// MUI
import { Grid } from "@mui/material";

const resolveIsEmptyBonus = (tiers = []) => tiers.length === 1 && tiers[0].bonuses?.length === 1 && tiers[0].bonuses[0].bonus?.value === 0;

const isEmptyBonusError = (makes = []) => {
	return makes.reduce((acc, make) => {
		const isEmptyBonus = resolveIsEmptyBonus(make.tiers || []);
		return acc && isEmptyBonus;
	}, true);
};

export default function renderContent(props) {
	const { sectionId = "", makes = [], readOnly = false, handleUpdate = () => {}, handleValidation = () => {} } = props;
	const hasEmptyBonuses = isEmptyBonusError(makes);

	return makes?.map((element, key) => (
		<Grid container key={`${element.make}_${key}`}>
			<Grid item xs={12} className={"models-tiered-area"}>
				<GrossBonus
					{...element}
					isEmptyBonus={hasEmptyBonuses}
					sectionId={sectionId}
					readOnly={readOnly}
					onActionUpdate={(make, model) => handleUpdate(sectionId, make, model)}
					onActionValidation={(make, isValid) => handleValidation(sectionId, make, isValid)}
				/>
			</Grid>
		</Grid>
	));
}
renderContent.propTypes = {
	sectionId: PropTypes.string,
	makes: PropTypes.array,
	readOnly: PropTypes.bool,
	handleUpdate: PropTypes.func,
	handleValidation: PropTypes.func,
};
